import { useEffect, useRef, useState } from "react";
import { useGetCustomers } from "../../../hooks/api/queries";

const useCustomerSearchField = ({ customerValue }) => {
  const [queryParams, setQueryParams] = useState({
    query: customerValue,
    all_business: 1,
    per_page: 50,
  });
  const [isEnableSearch, setIsEnableSearch] = useState(false);
  const [isDropDown, setIsDropDown] = useState(false);

  const serachRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (serachRef.current && !serachRef.current.contains(event.target))
        setIsDropDown(false);
    };
    document.addEventListener("click", handleClickOutside);
  }, [serachRef]);

  const { data, isLoading } = useGetCustomers({
    isEnabled: isEnableSearch,
    queryParams,
  });

  return {
    serachRef,
    isLoading,
    isEnableSearch,
    customersNames: data?.data || [],
    isDropDown,
    queryParams,
    setQueryParams,
    setIsDropDown,
    setIsEnableSearch,
  };
};
export default useCustomerSearchField;
